
import DxTextBox from "devextreme-vue/text-box";
import { defineComponent } from "vue";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";

export default defineComponent({
  components: {
    DxTextBox,
    DxValidator,
    DxRequiredRule,
  },
  emits: ["update:value", "changed"],
  props: {
    mode: { type: String, required: false },
    //из devExtreme значение
    value: { required: true },
    //максимальная длина текста
    maxLength: { type: Number, required: false, default: undefined },
    //показатель видимости контрола
    visible: { type: Boolean, required: false, default: true },
    //показатель валидации
    isValid: { type: Boolean, required: false, default: true },
    //placeholder
    placeholder: { type: String, required: false, default: "" },
    //показатель возможности изменения значения
    readOnly: { type: Boolean, required: false, default: false },
    //показатель возможности взаимодействия
    disabled: { type: Boolean, required: false, default: false },
    //подсказка при наведении на контрол
    hint: { type: String, required: false, default: undefined },
    //показавать кнопку удаления
    hasEmptyValue: { type: Boolean, required: false, default: true },
    // стиль
    stylingMode: { type: String, required: false, default: "underlined" },
    //группа валидации (см. dxValidator.validationGroup)
    validationGroup: { required: false, default: "baseValidationGroup" },

    contentReady: {
      type: Function,
      required: false,
      default: () => {
        return;
      },
    },
    enterKey: {
      type: Function,
      required: false,
      default: () => {
        return;
      },
    },
  },
  methods: {
    valueChanged(e: any) {
      this.$emit("update:value", e.value);
      this.$emit("changed", e);
    },
  },
  data() {
    return {
      modelValue: "",
    };
  },
  watch: {
    value: {
      handler: function (value) {
        this.modelValue = value;
      },
    },
  },
  created() {
    (this as any).modelValue = this.value;
  },
});
